import { FloatingDelayGroup } from '@floating-ui/react';
import React from 'react';

export interface DataTableToolbarContainerProps {
  className?: string;
}

export const DataTableToolbarContainer: React.FC<DataTableToolbarContainerProps> = ({
  children,
  className,
}) => {
  return (
    <FloatingDelayGroup delay={{ open: 700, close: 300 }}>
      <div
        className={`
            h-10
            bg-voxel-gray-50
            flex flex-row items-center gap-1
            px-2.5
            ${className}
      `}
      >
        {children}
      </div>
    </FloatingDelayGroup>
  );
};

export default DataTableToolbarContainer;
